export interface FileMap {
  [file: string]: Record<string, unknown>
}

export class FileLoader {
  public static loadFilesWithNode = (dirName: string) => {
    //
    const recipeMap: FileMap = {}
    let directory

    try {
      const fs = require('fs')
      const path = require('path')
      directory = path.resolve(__dirname, `${dirName}`)

      fs.readdirSync(directory).forEach((file) => {
        const fullPath = path.resolve(__dirname, `${directory}/${file}`)
        if (fs.lstatSync(fullPath).isFile()) {
          const fileWithoutExtension = file.replace('.json', '')
          try {
            recipeMap[fileWithoutExtension] = JSON.parse(
              fs.readFileSync(fullPath, 'utf-8')
            )
          } catch (errorResult) {
            const message = `FileLoader.loadFilesWithNode. Read file [${fileWithoutExtension}] Error: ${errorResult.message}`
            throw Error(message)
          }
        }
      })
    } catch (errorRead) {
      const message = `FileLoader.loadFilesWithNode. Load recipes from directory '${directory}' Error: ${JSON.stringify(
        errorRead.message
      )}`
      throw Error(message)
    }
    return recipeMap
  }
}

export default FileLoader
